import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input,
  OnChanges,
  SimpleChanges,
  Output,
  EventEmitter
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Template } from "@modules/template/student/models/template";
import { Location } from "@modules/location/models/location";
import { UserProfile } from "@modules/identity/models/user";
import { Guid } from "@core/utils/guid";
import { ConfirmEmailValidator } from "@shared/validators/confirm-email.validator";
import { omit } from "lodash";
import { TRANSLATION_SCOPE } from "@modules/template/student/i18n/scope";

@Component({
  selector: 'app-template-request-form',
  templateUrl: './template-request-form.component.html',
  styleUrls: ['./template-request-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TemplateRequestFormComponent implements OnInit,OnChanges {

  @Input() templates: Template[];
  @Input() regions: Location[];
  @Input() user: UserProfile;
  @Input() selectedTemplateId: string;
  @Output() submitTemplateRequest: EventEmitter<any> = new EventEmitter<any>();

  public translationScope = TRANSLATION_SCOPE+'.course_request_form';
  templateRequestFormGroup: FormGroup;

  constructor(private formBuilder: FormBuilder) {
    this.createTemplateCourseRequestFromGroup();
  }

  ngOnInit(): void {

  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes && changes.user && changes.user.currentValue) {
      this.patchUserInformation(changes.user.currentValue);
    }
    if(changes && changes.instructors && changes.instructors.currentValue.length > 0) {
      this.templateRequestFormGroup.get('instructorId').enable();
    }
  }

  getSelectedRegionName(selectedRegionId: string): string {
    const { name: selectedRegionName } = this.regions.find((region) => (region.id === selectedRegionId)) || { name: ''};
    return selectedRegionName;
  }

  private createTemplateCourseRequestFromGroup(): void {
    this.templateRequestFormGroup = this.formBuilder.group({
      courseTemplateId: [null,Validators.required],
      regionId: [null,Validators.required],
      userName: [null,Validators.required],
      userEmail: [null,[Validators.required,Validators.email]],
      confirmEmail: [null,[Validators.required,Validators.email]],
      instructorId: [null],
      userId: [null],
      description:[null],
    }, {
      validators: [ ConfirmEmailValidator.validateEmail('userEmail', 'confirmEmail') ]
    } );
    this.templateRequestFormGroup.get('instructorId').disable({onlySelf: true});
  }

  private patchUserInformation(user: UserProfile): void {
    this.templateRequestFormGroup.get('userName').patchValue(user.name);
    this.templateRequestFormGroup.get('userEmail').patchValue(user.email);
    this.templateRequestFormGroup.get('confirmEmail').patchValue(user.email);
    this.templateRequestFormGroup.get('userId').patchValue(user.sub);
  }

  submitTemplateRequestForm(): void {
    this.submitTemplateRequest.emit({
      id: Guid.NewGuid(),
      ...omit(this.templateRequestFormGroup.getRawValue(), 'confirmEmail'),
      instructorName: null,
      regionName: this.getSelectedRegionName(this.templateRequestFormGroup.getRawValue().regionId)
    });
  }
}
